import React, {useEffect, useState} from 'react'
import {css} from '@emotion/core'
import {getTheme, getThemeStyles} from '../util/theme'
import {getLanguageCode} from '../util/locale'
import Layout from '../components/Layout'
import SearchForm from '../components/error/search-form'
import {logDpl, EVENTS} from '../util/dpl'

import StartpageLogoNew from '../images/startpage-logo-error.svg'

import advancedSearchData from '../translations/advanced-search.json'

const AdvancedSearch = ({languageCode}) => {
    const lang = languageCode || getLanguageCode()

    const {advancedSeo, advancedMessage, advancedTagLine} = advancedSearchData[lang]

    const [theme, setTheme] = useState('light')
    const [themeStyles, setThemeStyles] = useState({})

    useEffect(() => {
        setTheme(getTheme())
        setThemeStyles(getThemeStyles())
    }, [theme, themeStyles])

    useEffect(() => {
        logDpl(EVENTS.StartpageAdvancedSearchVisit, {
            url: window.location.href || '',
        })
    }, [])

    return (
        <Layout
            title={advancedSeo.title}
            description={advancedSeo.description}
            lang={lang}
            canonicalPath="/advanced/"
            theme={theme}
            themeStyles={themeStyles}
            errorHeader={advancedMessage}
            noindex
        >
            <section
                className="wrapper"
                css={css`
                    max-width: 100%;
                    overflow: hidden;
                    padding: 0 1rem;
                    min-height: 500px;
                    height: calc(100vh - 147px);
                `}
            >
                <div
                    className="search-container"
                    css={css`
                        max-width: 500px;
                        margin: 0 auto;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        position: relative;
                    `}
                >
                    <div
                        css={css`
                            width: 240px;
                            margin-top: 12.75rem;
                        `}
                    >
                        <StartpageLogoNew
                            css={css`
                                width: 100%;
                                path {
                                    &:nth-of-type(2) {
                                        fill: ${themeStyles.primaryTextColor};
                                    }
                                }
                            `}
                            width="100%"
                            height="100%"
                            viewBox="0 0 115 25"
                        />
                    </div>
                    <SearchForm themeStyles={themeStyles} />
                    <div className="tagline">
                        <p
                            css={css`
                                color: ${themeStyles.primaryTextColor};
                                font-size: 18px;
                                text-align: center;
                            `}
                        >
                            {advancedTagLine}
                        </p>
                    </div>
                </div>
            </section>
            <div
                className="footer"
                css={css`
                    position: absolute;
                    bottom: 0;
                    height: 1.5rem;
                    width: 100%;
                    background: ${themeStyles.brandBlue};
                `}
            />
        </Layout>
    )
}

export default AdvancedSearch
